import styled, { css } from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import { FlexBoxCol, FlexBoxRow } from '@ertelecom/ui-react/components/layouts/flexBoxGrid';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
import { breakpoints } from '~/src/components/Header/styled';

export const MainMenuWrapper = styled.div<{ isFixed: boolean, isTablet: boolean, menuItemHeight: number }>`
    flex-wrap: nowrap;

    ${p => !p.isTablet && css`
        &:before {
            content: '';
            position: fixed;
            top: ${p.isFixed ? '48px' : '74px'};
            left: 0;
            right: 0;
            height: ${p.menuItemHeight + 'px'};
            background: ${COLORS.lightGrey};
            box-shadow: 0 8px 20px -2px rgba(41, 44, 48, 0.1);
            transform-origin: top center;
            transition: height .3s linear;
        }
    `}

    @media (max-width: ${breakpoints.sDesktop}) {
        flex-direction: column;
        gap: 20px;
    }
`;

export const MenuItem = styled.div<{ isPromoted?: boolean, withButton?: boolean }>`
    position: relative;
    align-self: center;
    white-space: nowrap;

    &:not(:first-child) {
        padding-left: ${p => p.isPromoted ? '31px' : '12px'};
    }

    &:not(:last-child) {
        padding-right: 12px;
    }

    & > a {
        color: ${COLORS.black};
        font-size: 14px;
        padding-top: 16px;
        padding-bottom: 16px;
        position:relative;

        &:after {
            content: '';
            position: absolute;
            left: 0;
            width: 0;
            height: 4px;
            bottom: -1px;
            background: #F93601;
            transition: all 0.2s ease;
            opacity: 0;
        }
    }

    ${p => p.isPromoted && css`
        &:before {
            content: '';
            position: absolute;
            left: 13px;
            top: 17px;
            width: 11px;
            height: 9px;
            background: url('${require('~/static/images/menu/promo.svg')}') no-repeat;
            background-size: cover;
        }
    `}

    &:hover {
        & > a {
            &:after {
                width: 100%;
                opacity: 1;
            }
            & + div > div {
                opacity: 1;
            }
        }
        & > div {
            opacity: 1;
            visibility: visible;
            transform: scaleY(1);
        }
    }
`;

export const CollapsedMenu = styled.div<{ isFixed: boolean }>`
    position: fixed;
    left: 0;
    right: 0;
    top: ${p => p.isFixed ? '48px' : '74px'};
    flex-wrap: nowrap;
    align-items: center;
    background: ${COLORS.lightGrey};
    opacity: 0;
    visibility: hidden;
    transform-origin: top center;
    transform: scaleY(0);
    transition: transform .3s linear, opacity .3s linear, visibility .3s linear;
    overflow: hidden;
    z-index: 7;
`;

export const CollapsedWrapper = styled(GridContainer)`
    opacity: 0;
    display: block;
    margin-top: 48px;
    margin-bottom: 48px;
    transition: opacity .1s linear;
`;

export const Row = styled(FlexBoxRow)``;

export const Col = styled(FlexBoxCol)``;

export const MenuTitle = styled.div`
    color: ${COLORS.black};
    margin-bottom: 8px;
    font-size: 14px;
`;

export const MenuDescription = styled.div`
    color: ${COLORS.darkGrey};
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 1.3;
    white-space: pre-wrap;
`;

export const Button = styled(StyledButton)`
    width: auto;
    align-self: center;
    height: 45px;
    min-width: 138px;
    padding: 14px 22px;
    font-size: 14px;
    line-height: 1.2;
`;

export const MenuItemsRow = styled(FlexBoxRow)`
    flex-direction: column;
    max-height: 200px;
`;

export const ChildMenuItem = styled.a`
    display: inline-block;
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 1.1;
    color: ${COLORS.black};
    transition: color 0.3s ease;
    white-space: pre-wrap;
    
    &:hover {
        color: ${COLORS.red};
    }
`;
